module.exports = __webpack_public_path__ + "img/listria_t2.d4bb6492.jpg";